import React from 'react';

class OldEditorNotice extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    console.log('Not rendering - old editor');
    return (
      <div className="old-editor">
        <div className="old-editor-wrapper">
          Wix Pro Gallery is not available for the old Editor.
          <br />
          Click{' '}
          <a
            href="https://support.wix.com/article/switching-to-the-new-wix-editor"
            target="_blank"
          >
            here
          </a>
          to learn how to switch to the new Editor.
        </div>
      </div>
    );
  }
}

export default OldEditorNotice;
